import { FC, ReactNode } from "react"

interface SectionCardProps {
  icon: ReactNode
  title: string
  children: ReactNode
  right?: ReactNode
}

const SectionCard: FC<SectionCardProps> = ({
  icon,
  title,
  right,
  children
}) => (
  <div className="bg-white rounded shadow-sm p-6">
    <div className="flex items-center justify-between mb-5">
      <div className="flex items-center gap-2">
        <span className="text-violet-400">{icon}</span>
        <span className="text-sm font-medium text-neutral-800">{title}</span>
      </div>
      {right}
    </div>
    {children}
  </div>
)

export default SectionCard
